import BottomSheet from '@rio-cloud/rio-uikit/BottomSheet';
import Button from '@rio-cloud/rio-uikit/Button';
import ExpanderPanel from '@rio-cloud/rio-uikit/ExpanderPanel';
import { type ReactNode, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { loadFromLocalStorage, saveInLocalStorage } from '../../common/onboarding/handleLocalStorage';

export const CONTRACT_CHANGES_BOTTOM_SHEET_STORAGE_KEY = 'contract-changes-bottom-sheet-dismissed-v1';

const renderStrong = (chunks: ReactNode) => <strong>{chunks}</strong>;
const renderListItem = (chunks: ReactNode) => <li>{chunks}</li>;

interface Props {
    onDismiss?: VoidFunction;
}

export const ContractChangesBottomSheet = ({ onDismiss }: Props) => {
    const [showBottomSheet, setShowBottomSheet] = useState(
        () => !loadFromLocalStorage(CONTRACT_CHANGES_BOTTOM_SHEET_STORAGE_KEY)
    );
    const [showDetails, setShowDetails] = useState(false);

    const handleClose = () => {
        setShowBottomSheet(false);
        saveInLocalStorage(CONTRACT_CHANGES_BOTTOM_SHEET_STORAGE_KEY, true);
        onDismiss?.();
    };

    if (!showBottomSheet) {
        return null;
    }

    return (
        <BottomSheet
            show
            showCloseButton={false}
            onClose={() => {}}
            title={<FormattedMessage id='marketplace.contractChanges.bottomSheet.title' />}
            width={500}
            detach
            hasBackdrop
            bodyClassName='padding-25'
        >
            <p className='margin-top-0'>
                <FormattedMessage id='marketplace.contractChanges.bottomSheet.summary' values={{ b: renderStrong }} />
            </p>
            {showDetails ? (
                <>
                    <ul>
                        <FormattedMessage
                            id='marketplace.contractChanges.bottomSheet.changes'
                            values={{ b: renderStrong, li: renderListItem }}
                        />
                    </ul>
                    <p>
                        <FormattedMessage
                            id='marketplace.contractChanges.bottomSheet.renewalExplanation'
                            values={{ b: renderStrong }}
                        />
                    </p>
                    <ExpanderPanel
                        title={
                            <FormattedMessage id='marketplace.contractChanges.bottomSheet.activeContracts.question' />
                        }
                        bsStyle='default'
                        titleClassName='text-bold'
                        open={false}
                    >
                        <FormattedMessage
                            id='marketplace.contractChanges.bottomSheet.activeContracts.answer'
                            values={{ b: renderStrong }}
                        />
                    </ExpanderPanel>
                    <Button bsStyle={Button.DEFAULT} onClick={handleClose}>
                        Close
                    </Button>
                </>
            ) : (
                <div className='display-flex gap-10'>
                    <Button bsStyle={Button.PRIMARY} onClick={() => setShowDetails(true)}>
                        <FormattedMessage id='marketplace.contractChanges.bottomSheet.readMore' />
                    </Button>
                    <Button bsStyle={Button.DEFAULT} onClick={handleClose}>
                        Close
                    </Button>
                </div>
            )}
        </BottomSheet>
    );
};
